import { render, staticRenderFns } from "./ProvisionRuleConfig.vue?vue&type=template&id=0ff2291b&scoped=true&"
import script from "./ProvisionRuleConfig.vue?vue&type=script&lang=js&"
export * from "./ProvisionRuleConfig.vue?vue&type=script&lang=js&"
import style0 from "./ProvisionRuleConfig.vue?vue&type=style&index=0&id=0ff2291b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff2291b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ff2291b')) {
      api.createRecord('0ff2291b', component.options)
    } else {
      api.reload('0ff2291b', component.options)
    }
    module.hot.accept("./ProvisionRuleConfig.vue?vue&type=template&id=0ff2291b&scoped=true&", function () {
      api.rerender('0ff2291b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ProvisionData/ProvisionRuleConfig.vue"
export default component.exports